import { Fragment } from "react";
import {
  BaseGameDescription,
  PointsByDifficulty,
} from "shared/games/allTechniqueGameDescriptions";
import { Difficulty } from "shared/games/Difficulty";
import capitalize from "util/capitalize";
import useAutoOverflowScrollContainerGradients from "util/useAutoOverflowScrollContainerGradients";
import InlinePointsText from "./InlinePointsText";

interface Props {
  games: BaseGameDescription[];
  difficulty: Difficulty;
  points?: PointsByDifficulty | undefined;
}

export default function DifficultyDescriptions({
  games,
  difficulty,
  points,
}: Props) {
  const { scrollContainerRef, gradients, topSensor, bottomSensor } =
    useAutoOverflowScrollContainerGradients<HTMLUListElement>();
  const noGames = games.length === 0;

  return (
    <div className="relative ">
      <ul
        ref={scrollContainerRef}
        className="mb-2 max-h-[100px] overflow-auto overscroll-contain text-sm text-white"
      >
        {topSensor}

        {noGames && (
          <div>
            <strong className="text-yellow-500">No games selected.</strong>{" "}
            Please pick at least one of the games above so that you can start
            training those ears!
          </div>
        )}

        {games.map((game, i) => {
          return (
            <Fragment key={game.title + i}>
              <li>
                <strong>
                  {game.title}
                  {/* {points && <InlinePointsText points={points[difficulty]} />} */}
                </strong>
                : {game.description[difficulty]}
              </li>

              {i !== games.length - 1 && (
                <hr className="border-1 my-2 border-dashed border-white" />
              )}
            </Fragment>
          );
        })}

        {bottomSensor}
      </ul>

      {gradients}
    </div>
  );
}
